// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getAuth} from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// picanteriaipiales.colombia@gmail.com
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBk0d0clw8v3Ojx6SaIoJBUFVY35ynWAYA",
    authDomain: "picanteriav2.firebaseapp.com",
    projectId: "picanteriav2",
    storageBucket: "picanteriav2.firebasestorage.app",
    messagingSenderId: "989644192044",
    appId: "1:989644192044:web:e350f27f0cab3e9e8a5489",
    measurementId: "G-EC3DCMZGWV"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const auth = getAuth(app)
export const fire = getFirestore(app)
export const storage = getStorage(app)

